import update from 'immutability-helper'
import { createReducer } from '@reduxjs/toolkit'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_ADS,
  GET_ADS_SUCCESS,
  GET_ADS_FAILURE,
  CLEAR_ADS,
  CREATE_AD,
  CREATE_AD_SUCCESS,
  CREATE_AD_FAILURE,
  CLEAR_CREATE_AD,
  CREATE_ADS_BATCH,
  CREATE_ADS_BATCH_SUCCESS,
  CREATE_ADS_BATCH_FAILURE,
  CLEAR_CREATE_ADS_BATCH,
  UPDATE_AD,
  UPDATE_AD_SUCCESS,
  UPDATE_AD_FAILURE,
  CLEAR_UPDATE_AD,
  DELETE_AD,
  DELETE_AD_SUCCESS,
  DELETE_AD_FAILURE,
  CLEAR_DELETE_AD,
  GET_AD,
  GET_AD_SUCCESS,
  GET_AD_FAILURE,
  CLEAR_AD,
  APPROVE_INTERNAL_AD,
  APPROVE_INTERNAL_AD_SUCCESS,
  APPROVE_INTERNAL_AD_FAILURE,
  CLEAR_APPROVE_INTERNAL_AD,
  DISAPPROVE_INTERNAL_AD,
  DISAPPROVE_INTERNAL_AD_SUCCESS,
  DISAPPROVE_INTERNAL_AD_FAILURE,
  CLEAR_DISAPPROVE_INTERNAL_AD,
  SET_AD_MODIFIED_DATA,
  SET_AD_CAROUSEL_SELECTED_INDEX,
  TOGGLE_IS_SOUND_MUTED,
  CLEAR_AD_PREVIEW,
  SORT,
  SET_ADS_SORT,
  CLEAR_VALIDATE_AD,
  VALIDATE_AD_FAILURE,
  VALIDATE_AD_SUCCESS,
  VALIDATE_AD,
  SET_SELECTED_AD_FOR_COPY,
  CLEAR_SELECTED_AD_FOR_COPY,
  COPY_AD,
  COPY_AD_SUCCESS,
  COPY_AD_FAILURE,
  CLEAR_COPY_AD,
  GET_FACEBOOK_POSTS,
  GET_FACEBOOK_POSTS_SUCCESS,
  GET_FACEBOOK_POSTS_FAILURE,
  CLEAR_FACEBOOK_POSTS,
  UPDATE_AD_STATUS,
  UPDATE_AD_STATUS_SUCCESS,
  UPDATE_AD_STATUS_FAILURE,
  UPDATE_ADS_LIST
} from '../actions/ads'
import { deleteItemById, updateItem } from '../../helpers/reducerHelpers'
import { getCookie } from '../../helpers/common'
import {
  INITIAL_CREATE_REDUCER,
  INITIAL_UPDATE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_LOADING_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_RESULTS_PAGING_REDUCER,
  InitialGetResultsPagingReducer,
  InitialGetReducer,
  InitialCreateReducer,
  InitialUpdateReducer,
  InitialDeleteReducer
} from '../../constants/reducer'
import {
  GetAdsSuccessPayload,
  GetAdsFailurePayload,
  GetAdSuccessPayload,
  GetAdFailurePayload,
  CreateAdSuccessPayload,
  CreateAdFailurePayload,
  ValidateAdPayload,
  ValidateAdSuccessPayload,
  ValidateAdFailurePayload,
  UpdateAdPayload,
  UpdateAdSuccessPayload,
  UpdateAdFailurePayload,
  DeleteAdPayload,
  DeleteAdSuccessPayload,
  DeleteAdFailurePayload,
  ApproveInternalAdPayload,
  ApproveInternalAdSuccessPayload,
  ApproveInternalAdFailurePayload,
  DisapproveInternalAdPayload,
  DisapproveInternalAdSuccessPayload,
  DisapproveInternalAdFailurePayload,
  SetSelectedAdForCopyPayload,
  CopyAdSuccessPayload,
  CopyAdFailurePayload,
  SetAdModifiedDataPayload,
  SetAdCarouselSelectedIndexPayload,
  SetAdsSortPayload,
  GetFacebookPostsSuccessPayload,
  GetFacebookPostsFailurePayload,
  CreateAdsBatchFailurePayload,
  CreateAdsBatchSuccessPayload,
  UpdateAdStatusPayload
} from '../types/ads'

const INITIAL_VALIDATE_AD_REDUCER = {
  ...INITIAL_LOADING_REDUCER,
  wasValidated: false,
  isValid: false,
  errors: {}
}

export type AdsInitialStateType = {
  ads: InitialGetResultsPagingReducer
  facebookPosts: InitialGetResultsPagingReducer
  ad: InitialGetReducer
  createdAd: InitialCreateReducer
  createAdsBatch: InitialCreateReducer
  validatedAd: {
    currentDomain: string
    domains: object
  }
  updatedAd: InitialUpdateReducer
  deletedAd: InitialDeleteReducer

  approveInternalAd: {
    [id: string]: {
      isLoading: boolean
      wasApproved: boolean
      error: null | object
    }
  }
  disapproveInternalAd: {
    [id: string]: {
      isLoading: boolean
      wasDisapproved: boolean
      error: null | object
    }
  }
  selectedAdForCopy: null | object
  copyAd: InitialCreateReducer
  adPreview: {
    adModifiedData: object
    adCarouselSelectedIndexes: object
    isSoundMuted: boolean
  }
  sort: object
}

const initialState: AdsInitialStateType = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  ads: INITIAL_GET_RESULTS_PAGING_REDUCER,
  facebookPosts: INITIAL_GET_RESULTS_PAGING_REDUCER,
  ad: INITIAL_GET_REDUCER,
  createdAd: INITIAL_CREATE_REDUCER,
  createAdsBatch: INITIAL_CREATE_REDUCER,
  validatedAd: {
    currentDomain: '',
    domains: {}
  },
  updatedAd: INITIAL_UPDATE_REDUCER,
  deletedAd: INITIAL_DELETE_REDUCER,
  approveInternalAd: {},
  disapproveInternalAd: {},
  selectedAdForCopy: null,
  copyAd: INITIAL_CREATE_REDUCER,
  adPreview: {
    adModifiedData: {},
    adCarouselSelectedIndexes: {},
    isSoundMuted: false
  },
  sort: getCookie(SORT) || {
    value: '',
    label: 'Default sort',
    sort_reverse: true
  }
}

export default createReducer(initialState, builder => {
  builder
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    .addCase(GET_ADS, state =>
      update(state, {
        ads: {
          $merge: {
            isLoading: true
          }
        }
      })
    )
    // You can chain calls, or have separate `builder.addCase()` lines each time
    .addCase(GET_ADS_SUCCESS, (state, action: GetAdsSuccessPayload) => {
      // request with pagination returns object, without - array, data structure is different,
      // when new data is fetched - replace it with set method,
      // when additional data with pagination just push to existed
      const updatedResults = Array.isArray(action.adsData)
        ? { results: { $set: action.adsData } }
        : { results: { $push: action.adsData.data } }

      return update(state, {
        ads: {
          ...updatedResults,
          $merge: {
            isLoading: false,
            wasLoaded: true,
            // request with pagination returns object, without - array, data structure is different,
            ...(!Array.isArray(action.adsData) && {
              paging: action.adsData.paging
            })
          }
        }
      })
    })
    .addCase(GET_ADS_FAILURE, (state, action: GetAdsFailurePayload) => {
      return update(state, {
        ads: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_ADS, state => {
      return update(state, {
        ads: { $set: initialState.ads }
      })
    })

    // get single ad data
    .addCase(GET_AD, state => {
      return update(state, {
        ad: {
          $merge: {
            isLoading: true
          }
        }
      })
    })
    .addCase(GET_AD_SUCCESS, (state, action: GetAdSuccessPayload) => {
      return update(state, {
        ad: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.adData
          }
        },
        // push to list if was requested
        ...(action.pushToList && {
          ads: {
            results: {
              $unshift: [action.adData]
            }
          }
        })
      })
    })
    .addCase(GET_AD_FAILURE, (state, action: GetAdFailurePayload) => {
      return update(state, {
        ad: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_AD, state => {
      return update(state, {
        ad: { $set: initialState.ad }
      })
    })

    // create ad
    .addCase(CREATE_AD, state => {
      return update(state, {
        createdAd: {
          $merge: {
            isLoading: true
          }
        }
      })
    })
    .addCase(CREATE_AD_SUCCESS, (state, action: CreateAdSuccessPayload) => {
      return update(state, {
        createdAd: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.adData
          }
        },
        ads: {
          results: {
            $unshift: [action.adData] as any
          }
        }
      })
    })
    .addCase(CREATE_AD_FAILURE, (state, action: CreateAdFailurePayload) => {
      return update(state, {
        createdAd: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_CREATE_AD, state => {
      return update(state, {
        createdAd: { $set: initialState.createdAd }
      })
    })
    // Create ads batch
    .addCase(CREATE_ADS_BATCH, state => {
      return update(state, {
        createAdsBatch: { $merge: { isLoading: true } }
      })
    })
    .addCase(CREATE_ADS_BATCH_SUCCESS, (state, action: CreateAdsBatchSuccessPayload) => {
      return update(state, {
        createAdsBatch: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.adsData
          }
        },
        ads: {
          // dv360 returns array of ads and array of exceptions.
          // Exception is an array of ads that were not created so we don't need to add them to the list
          results: {
            $unshift: action.adsData.ads
          }
        }
      })
    })
    .addCase(CREATE_ADS_BATCH_FAILURE, (state, action: CreateAdsBatchFailurePayload) => {
      return update(state, {
        createAdsBatch: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_CREATE_ADS_BATCH, state => {
      return update(state, {
        createAdsBatch: { $set: initialState.createAdsBatch }
      })
    })
    // validate ad
    .addCase(VALIDATE_AD, (state, action: ValidateAdPayload) => {
      const conversionDomain = action.adData.conversion_domain
      return update(state, {
        validatedAd: {
          domains: {
            $merge: {
              [conversionDomain]: {
                ...INITIAL_VALIDATE_AD_REDUCER,
                isLoading: true
              }
            }
          }
        }
      })
    })
    .addCase(VALIDATE_AD_SUCCESS, (state, action: ValidateAdSuccessPayload) => {
      return update(state, {
        validatedAd: {
          domains: {
            $merge: {
              [action.conversionDomain]: {
                ...INITIAL_VALIDATE_AD_REDUCER,
                isLoading: false,
                wasValidated: true,
                isValid: true
              }
            }
          }
        }
      })
    })
    .addCase(VALIDATE_AD_FAILURE, (state, action: ValidateAdFailurePayload) => {
      return update(state, {
        validatedAd: {
          domains: {
            $merge: {
              [action.conversionDomain]: {
                isLoading: false,
                wasValidated: true,
                isValid: false,
                error: action.error
              }
            }
          }
        }
      })
    })
    .addCase(CLEAR_VALIDATE_AD, state => {
      return update(state, {
        validatedAd: { $set: initialState.validatedAd }
      })
    })

    // update ad
    .addCase(UPDATE_AD, (state, action: UpdateAdPayload) => {
      return update(state, {
        updatedAd: {
          $merge: {
            isLoading: true,
            id: action.id
          }
        }
      })
    })

    .addCase(UPDATE_AD_SUCCESS, (state, action: UpdateAdSuccessPayload) => {
      const isArchived = action.adData.status === 'archived'
      return update(state, {
        ads: {
          // if we archive ad we should remove this ad from active/paused ads list,
          // we use for this purpose deleteItemById() method
          results: {
            $apply: isArchived
              ? (items: any[]) => deleteItemById(items, action.adData.id)
              : (items: any[]) => updateItem(items, action.adData)
          }
        },
        updatedAd: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        },
        ad: {
          $merge: {
            data: action.adData
          }
        }
      })
    })

    .addCase(UPDATE_AD_FAILURE, (state, action: UpdateAdFailurePayload) => {
      return update(state, {
        updatedAd: {
          $merge: {
            ...initialState.updatedAd,
            error: action.error
          }
        }
      })
    })

    .addCase(CLEAR_UPDATE_AD, state => {
      return update(state, {
        updatedAd: { $set: initialState.updatedAd }
      })
    })

    // update ad status is using updatedAd store
    .addCase(UPDATE_AD_STATUS, (state, action: UpdateAdStatusPayload) => {
      return update(state, {
        updatedAd: {
          $merge: {
            isLoading: true,
            id: action.updateData.id
          }
        }
      })
    })
    .addCase(UPDATE_AD_STATUS_SUCCESS, (state, action: UpdateAdStatusPayload) => {
      return update(state, {
        ads: {
          results: { $apply: (items: any[]) => updateItem(items, action.updateData) }
        },
        updatedAd: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        }
      })
    })
    .addCase(UPDATE_AD_STATUS_FAILURE, (state, action: UpdateAdFailurePayload) => {
      return update(state, {
        updatedAd: {
          $merge: {
            ...initialState.updatedAd,
            error: action.error
          }
        }
      })
    })

    // delete ad
    .addCase(DELETE_AD, (state, action: DeleteAdPayload) => {
      return update(state, {
        deletedAd: {
          $merge: {
            isLoading: true,
            id: action.id
          }
        }
      })
    })
    .addCase(DELETE_AD_SUCCESS, (state, action: DeleteAdSuccessPayload) => {
      return update(state, {
        ads: {
          results: {
            $apply: (items: any[]) => deleteItemById(items, action.id)
          }
        },
        deletedAd: { $merge: { isLoading: false, id: action.id, wasDeleted: true } }
      })
    })
    .addCase(DELETE_AD_FAILURE, (state, action: DeleteAdFailurePayload) => {
      return update(state, {
        deletedAd: { $merge: { isLoading: false, error: action.error } }
      })
    })
    .addCase(CLEAR_DELETE_AD, state => {
      return update(state, {
        deletedAd: { $set: initialState.deletedAd }
      })
    })

    // Approve internal ad
    .addCase(APPROVE_INTERNAL_AD, (state, action: ApproveInternalAdPayload) => {
      return update(state, {
        approveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: true
            }
          }
        }
      })
    })
    .addCase(APPROVE_INTERNAL_AD_SUCCESS, (state, action: ApproveInternalAdSuccessPayload) => {
      return update(state, {
        approveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: false,
              wasApproved: true
            }
          }
        },
        ads: {
          results: { $apply: (items: any[]) => updateItem(items, action.data, action.id) }
        }
      })
    })
    .addCase(APPROVE_INTERNAL_AD_FAILURE, (state, action: ApproveInternalAdFailurePayload) => {
      return update(state, {
        approveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    })
    .addCase(CLEAR_APPROVE_INTERNAL_AD, (state, action) => {
      return update(state, {
        approveInternalAd: {
          $merge: {
            [action.id]: null
          }
        }
      })
    })

    // Disapprove internal ad
    .addCase(DISAPPROVE_INTERNAL_AD, (state, action: DisapproveInternalAdPayload) => {
      return update(state, {
        disapproveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: true
            }
          }
        }
      })
    })
    .addCase(DISAPPROVE_INTERNAL_AD_SUCCESS, (state, action: DisapproveInternalAdSuccessPayload) => {
      return update(state, {
        disapproveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: false,
              wasDisapproved: true
            }
          }
        },
        ads: {
          results: {
            $apply: (items: any[]) => deleteItemById(items, action.id)
          }
        }
      })
    })
    .addCase(DISAPPROVE_INTERNAL_AD_FAILURE, (state, action: DisapproveInternalAdFailurePayload) => {
      return update(state, {
        disapproveInternalAd: {
          $merge: {
            [action.id]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    })
    .addCase(CLEAR_DISAPPROVE_INTERNAL_AD, (state, action) => {
      return update(state, {
        disapproveInternalAd: {
          $merge: {
            [action.id]: null
          }
        }
      })
    })

    // copy AD
    .addCase(SET_SELECTED_AD_FOR_COPY, (state, action: SetSelectedAdForCopyPayload) => {
      return update(state, {
        selectedAdForCopy: { $set: action.adData }
      })
    })
    .addCase(CLEAR_SELECTED_AD_FOR_COPY, state => {
      return update(state, {
        selectedAdForCopy: { $set: initialState.selectedAdForCopy }
      })
    })
    .addCase(COPY_AD, state => {
      return update(state, {
        copyAd: {
          $merge: {
            isLoading: true
          }
        }
      })
    })
    .addCase(COPY_AD_SUCCESS, (state, action: CopyAdSuccessPayload) => {
      return update(state, {
        copyAd: {
          $merge: {
            isLoading: false,
            data: action.copiedAdDetails,
            wasCreated: true
          }
        }
      })
    })
    .addCase(COPY_AD_FAILURE, (state, action: CopyAdFailurePayload) => {
      return update(state, {
        copyAd: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_COPY_AD, state => {
      return update(state, {
        copyAd: { $set: initialState.copyAd }
      })
    })

    // modified data
    .addCase(SET_AD_MODIFIED_DATA, (state, action: SetAdModifiedDataPayload) => {
      return update(state, {
        adPreview: { $merge: { adModifiedData: action.adModifiedData } }
      })
    })
    .addCase(SET_AD_CAROUSEL_SELECTED_INDEX, (state, action: SetAdCarouselSelectedIndexPayload) => {
      return update(state, {
        adPreview: {
          adCarouselSelectedIndexes: {
            $merge: {
              [action.adId]: action.selectedIndex
            }
          }
        }
      })
    })
    .addCase(TOGGLE_IS_SOUND_MUTED, state => {
      return update(state, {
        adPreview: { $merge: { isSoundMuted: !state.adPreview.isSoundMuted } }
      })
    })
    .addCase(CLEAR_AD_PREVIEW, state => {
      return update(state, {
        adPreview: { $set: initialState.adPreview }
      })
    })

    .addCase(SET_ADS_SORT, (state, action: SetAdsSortPayload) => {
      return update(state, {
        sort: { $set: action.sort }
      })
    })

    // get facebookPosts
    .addCase(GET_FACEBOOK_POSTS, state => {
      return update(state, {
        facebookPosts: {
          $merge: {
            isLoading: true
          }
        }
      })
    })
    .addCase(GET_FACEBOOK_POSTS_SUCCESS, (state, action: GetFacebookPostsSuccessPayload) => {
      return update(state, {
        facebookPosts: {
          $merge: {
            results: action.postsData,
            isLoading: false,
            wasLoaded: true
          }
        }
      })
    })
    .addCase(GET_FACEBOOK_POSTS_FAILURE, (state, action: GetFacebookPostsFailurePayload) => {
      return update(state, {
        facebookPosts: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_FACEBOOK_POSTS, state => {
      return update(state, {
        facebookPosts: { $set: initialState.facebookPosts }
      })
    })
    .addCase(UPDATE_ADS_LIST, (state, action) => {
      return update(state, {
        ads: {
          results: {
            $set: action.ads
          }
        }
      })
    })
})
